
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M6.05 4.14005L5.66 3.75005C5.27 3.36005 4.64 3.37005 4.26 3.75005L4.25 3.76005C3.86 4.15005 3.86 4.78005 4.25 5.16005L4.64 5.55005C5.03 5.94005 5.65 5.94005 6.04 5.55005L6.05 5.54005C6.44 5.16005 6.44 4.52005 6.05 4.14005ZM3.01 10.5H1.99C1.44 10.5 1 10.94 1 11.49V11.5C1 12.05 1.44 12.49 1.99 12.49H3C3.56 12.5 4 12.06 4 11.51V11.5C4 10.94 3.56 10.5 3.01 10.5ZM12.01 0.550049H12C11.44 0.550049 11 0.990049 11 1.54005V2.50005C11 3.05005 11.44 3.49005 11.99 3.49005H12C12.56 3.50005 13 3.06005 13 2.51005V1.54005C13 0.990049 12.56 0.550049 12.01 0.550049ZM19.75 3.76005C19.36 3.37005 18.73 3.37005 18.34 3.75005L17.95 4.14005C17.56 4.53005 17.56 5.16005 17.95 5.54005L17.96 5.55005C18.35 5.94005 18.98 5.94005 19.36 5.55005L19.75 5.16005C20.14 4.77005 20.14 4.15005 19.75 3.76005ZM17.94 18.8601L18.33 19.25C18.72 19.64 19.35 19.64 19.74 19.25C20.13 18.8601 20.13 18.23 19.74 17.84L19.35 17.4501C18.96 17.0601 18.33 17.0701 17.95 17.4501C17.55 17.85 17.55 18.4701 17.94 18.8601ZM20 11.49V11.5C20 12.05 20.44 12.49 20.99 12.49H22C22.55 12.49 22.99 12.05 22.99 11.5V11.49C22.99 10.94 22.55 10.5 22 10.5H20.99C20.44 10.5 20 10.94 20 11.49ZM12 5.50005C8.69 5.50005 6 8.19005 6 11.5C6 14.81 8.69 17.5 12 17.5C15.31 17.5 18 14.81 18 11.5C18 8.19005 15.31 5.50005 12 5.50005ZM11.99 22.4501H12C12.55 22.4501 12.99 22.01 12.99 21.46V20.5C12.99 19.9501 12.55 19.51 12 19.51H11.99C11.44 19.51 11 19.9501 11 20.5V21.46C11 22.01 11.44 22.4501 11.99 22.4501ZM4.25 19.24C4.64 19.63 5.27 19.63 5.66 19.24L6.05 18.85C6.44 18.4601 6.43 17.83 6.05 17.4501L6.04 17.4401C5.65 17.0501 5.02 17.0501 4.63 17.4401L4.24 17.83C3.86 18.23 3.86 18.85 4.25 19.24Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-wb-sunny`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconWbSunny

    ```js
    <b-new-b-icon-wb-sunny />
    ```
</docs>


